/* 
  Combines multiple 'connects' together to allow namespaced data

  Grabbed from this article: 
  https://blog.cloudboost.io/the-elegance-of-decorated-redux-b0bd7e2de16a 
*/

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export default function combine(mapConnectsToProps) {
  const connectsKeys = Object.keys(mapConnectsToProps);

  const combinedMapStateToProps = (state, ownProps) => {
    const stateProps = {};

    connectsKeys.forEach((connectKey) => {
      const mapStateToProps = mapConnectsToProps[connectKey].mapStateToProps;

      if (mapStateToProps) {
        stateProps[connectKey] = mapStateToProps(state, ownProps);
      }
    });

    return stateProps;
  };

  const combinedMapDispatchToProps = (dispatch, ownProps) => {
    const dispatchProps = {};

    connectsKeys.forEach((connectKey) => {
      const mapDispatchToProps = mapConnectsToProps[connectKey].mapDispatchToProps;

      if (mapDispatchToProps) {
        dispatchProps[connectKey] = typeof mapDispatchToProps === 'object' ?
          bindActionCreators(mapDispatchToProps, dispatch) :
          mapDispatchToProps(dispatch, ownProps);
      }
    });

    return dispatchProps;
  };

  const combinedMergeProps = (stateProps, dispatchProps, ownProps) => {
    const mergedProps = {};

    connectsKeys.forEach((connectKey) => {
      const statePropsForKey = stateProps[connectKey];
      const dispatchPropsForKey = dispatchProps[connectKey];

      mergedProps[connectKey] = { ...statePropsForKey, ...dispatchPropsForKey };
    });

    return { ...ownProps, ...mergedProps };
  };

  return function useCombineConnect(Component) {
    return connect(
      combinedMapStateToProps,
      combinedMapDispatchToProps,
      combinedMergeProps,
    )(Component);
  };
}


// WEBPACK FOOTER //
// ./src/connects/combine.js